import React from 'react';
import { FaTrashAlt } from "react-icons/fa";
import Swal from 'sweetalert2';

interface SourceDeleteButtonProps {
  sourceId: string;
  sourceName: string;
  onDelete: (sourceId: string) => void;
}

export const SourceDeleteButton: React.FC<SourceDeleteButtonProps> = ({
  sourceId,
  sourceName,
  onDelete,
}) => {
  const handleCopyClick = async () => {
    const result = await Swal.fire({
      title: 'Eliminar Tienda',
      text: `¿Está seguro de que desea eliminar la tienda "${sourceName}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#4F46E5',
      cancelButtonColor: '#6B7280'
    });

    if (result.isConfirmed) {
      onDelete(sourceId);
      Swal.fire({
        title: 'Tienda Eliminada',
        text: `La tienda se ha eliminado correctamente"`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });
    }
  };

  return (
    <button
      onClick={handleCopyClick}
      className="p-1.5 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-50"
      title={`Eliminar tienda ${sourceName}`}
    >
      <FaTrashAlt size={16} />
    </button>
  );
};